import { fetcher } from '@commenda/utils';
import { ICommendaNexus } from './types';

/**
 * Imperative fetch function for nexus data.
 * Use this when you need to fetch nexus data outside of React hooks (e.g., in Promise.all).
 */
export async function fetchNexusData(
  corporationId: number
): Promise<{ success: boolean; data: ICommendaNexus[] | null }> {
  const query = new URLSearchParams();
  query.append('corporationId', corporationId.toString());

  const response = await fetcher(`new-sales-tax/nexus?${query}`, {
    method: 'GET',
  });

  if (!response.ok) {
    return { success: false, data: null };
  }

  const json = await response.json();
  return { success: response.ok, data: json.data };
}
